// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__IaaRj","active":"Panel_active__CVWqF"};